<template>
  <section class="section-container">
    <div class="content-wrapper">
      <contentheading
        :button="$t('supplierusers.add')"
        :title="$t('supplierusers.add')"
        url="supplier_users_add"/>
      <div class="row">
        <div class="col-xl-12">
          <div class="card card-default mb-2">
            <div class="card-body">
              <h4 class="mb-0">{{ supplier.name }}</h4>
              {{ $t('supplierusers.registration-code') }}: {{ supplier.registration_code }}
            </div>
          </div>
        </div>
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <search @make_search="make_search"/>
                <table class="table table-striped dataTable my-4 w-100" id="supplier_users">
                  <thead>
                    <tr>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'first_name',
                          'sorting_desc': ordering === '-first_name'}"
                        @click="order('first_name')">{{ $t('supplierusers.first-name') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'last_name',
                          'sorting_desc': ordering === '-last_name'}"
                        @click="order('last_name')">{{ $t('supplierusers.last-name') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'email',
                          'sorting_desc': ordering === '-email'}"
                        @click="order('email')">{{ $t('supplierusers.email') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'personal_code',
                          'sorting_desc': ordering === '-personal_code'}"
                        @click="order('personal_code')">{{ $t('supplierusers.personal-code') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'phone',
                          'sorting_desc': ordering === '-phone'}"
                        @click="order('phone')">{{ $t('supplierusers.phone') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'position',
                          'sorting_desc': ordering === '-position'}"
                        @click="order('position')">{{ $t('supplierusers.position') }}
                      </th>
                      <th>{{ $t('supplierusers.groups') }}</th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'is_active',
                          'sorting_desc': ordering === '-is_active'}"
                        @click="order('is_active')">{{ $t('supplierusers.status') }}
                      </th>
                      <th
                        :class="{
                          'sorting_asc': ordering === 'last_login',
                          'sorting_desc': ordering === '-last_login'}"
                        @click="order('last_login')">{{ $t('supplierusers.last-login') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="row.id" class="gradeX" v-for="(row, index) in rows">
                      <td>{{ row.first_name }}</td>
                      <td>{{ row.last_name }}</td>
                      <td>{{ row.email }}</td>
                      <td>{{ row.personal_code }}</td>
                      <td>{{ row.phone }}</td>
                      <td>{{ row.position }}</td>
                      <td>{{ row.warehouse_groups_tags }}</td>
                      <td>{{ row.is_active ? 'Active': 'Disabled' }}</td>
                      <td>{{ row.last_login | formatDateTime }}</td>
                      <td>
                        <router-link
                          :to="{name: 'supplier_users_edit', params: {sup_id: supplier.id, id: row.id}}"
                          class="far fa-edit"
                        />
                        <button
                          class="btn btn-link pl-1 pt-1"
                          :title="$t('workers.button-delete')"
                          @click="remove_account(row.id, index)">
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * 30 + 1"
                  :to="(page - 1) * 30 + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Contentheading from '@/components/Contentheading.vue'
import message from '@/message'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'

const getData = (id, route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'id'
  const page = parseInt(route.query.page) || 1

  Promise.all([
    api.get(`/suppliers/${id}/`),
    api.get('/supplier_users/?is_admin=false', {
      params: {
        search: search,
        ordering: ordering,
        page: page,
        supplier: id
      }
    })
  ])
    .then(([supplier, users]) => {
      next({
        rows: users.data.results,
        search: search,
        ordering: ordering,
        pages: users.data.pages,
        count: users.data.count,
        page: page,
        supplier: supplier.data
      })
    })
}

export default {
  components: {
    contentheading: Contentheading,
    pagination: Pagination,
    search: Search
  },
  data () {
    return {
      rows: [],
      search: null,
      ordering: null,
      pages: null,
      count: null,
      page: null,
      supplier: {}
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'users'
    this.$parent.submenu = 'suppliers'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
		is_user_able_to_change_view_proposals () {
			return this.$store.getters.user_group === 'Administrator' || this.$store.getters.user_group === 'Contractor'
		},
		save () {
			this.errors = {}
			let tagsGroups = []
			for (var n in this.warehouse_group) {
				tagsGroups.push(this.warehouse_group[n].name)
			}

			const data = objectToFormData({
				id: this.supplier_user.id,
				supplier__id: this.supplier_user.supplier__id,
				supplier__is_employees_can_view_proposal: this.supplier_user.supplier__is_employees_can_view_proposal,
				supplier__name: this.supplier_user.supplier__name,
				supplier__registration_code: this.supplier_user.supplier__registration_code,
				first_name: this.supplier_user.first_name,
				last_name: this.supplier_user.last_name,
				email: this.supplier_user.email,
				personal_code: this.supplier_user.personal_code,
				group: this.supplier_user.group,
				phone: this.supplier_user.phone,
				position: this.supplier_user.position,
				warehouse_group: this.warehouse_group,
				warehouse_groups: tagsGroups,
				is_active: this.supplier_user.is_active,
				is_admin: this.supplier_user.is_admin
			})

			if (this.supplier_user.id) {
				api.patch(`/supplier_users/${this.supplier_user.id}/`, data)
					.then(() => {
						message.success(this.$i18n.t('supplier.updated'))
						this.$router.push({name: 'suppliers'})
					})
					.catch(error => {
						let errors = parseApiError(error, this.$i18n)
						if (error.response && error.response.status === 400) {
							this.errors = errors
							if (!tagsGroups.length) {
								this.errors['warehouse_groups'] = [this.$i18n.t('one.group')]
							}
						} else {
							message.error(errors)
						}
					})
			} else {
				api.post('/supplier_users/', data)
					.then(() => {
						message.success(this.$i18n.t('supplier.added'))
						if (this.more) {
							this.supplier_user = {
								supplier__id: null,
								supplier__name: '',
								supplier__registration_code: '',
								supplier__is_employees_can_view_proposal: false,
								first_name: '',
								last_name: '',
								email: '',
								personal_code: '',
								phone: '',
								position: '',
								group: 'SUPPLIER',
								is_active: true,
								is_admin: false,
								warehouse_groups: []
							}
							this.warehouse_group = []
							this.warehouse_groups = []
							this.$router.push({name: 'supplier_add'})
						} else {
							this.$router.push({name: 'suppliers'})
						}
					})
					.catch(error => {
						let errors = parseApiError(error, this.$i18n)
						if (error.response && error.response.status === 400) {
							this.errors = errors
							if (!tagsGroups.length) {
								this.errors['warehouse_groups'] = [this.$i18n.t('one.group')]
							}
						} else {
							message.error(errors)
						}
					})
			}
		},
		addGroup (newName) {
			this.warehouse_group.push({
				name: newName
			})
    },
    beforeRouteEnter (to, from, next) {
      getData(to.params.sup_id, to, data => {
        next(vm => {
          Object.assign(vm.$data, data)
        })
      })
    },
    beforeRouteUpdate (to, from, next) {
      getData(to.params.sup_id, to, data => {
        Object.assign(this.$data, data)
        next()
      })
    }
	},

}
</script>



// WEBPACK FOOTER //
// src/views/Supplierusers.vue